module.exports = __webpack_public_path__ + "static/img/huo2.09436608.gif";